import { render } from "./BuyDetail.vue?vue&type=template&id=d992e018&scoped=true&ts=true&lang=pug"
import script from "./BuyDetail.vue?vue&type=script&lang=ts"
export * from "./BuyDetail.vue?vue&type=script&lang=ts"

import "./BuyDetail.vue?vue&type=style&index=0&id=d992e018&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d992e018"]])

export default __exports__